// The full X12 Unit or Basis for Measurement Code list (DE 355) — shared by
// every "what unit is this quantity expressed in" position across the 850's
// PO1 (baseline item) loop and the 852's QTY (item activity) segment.
// Transcribed from the reference document
// "00 - Envelope and Common Qualifiers.txt"'s "Unit or Basis for Measurement
// Code" section.
//
// Each entry's `label` is the short name (used for the coded value's inline
// display); see dictionary/types.ts's `CodeListEntry`.

import type {CodeListEntry} from './types';

export const UNIT_OR_BASIS_FOR_MEASUREMENT_CODES: CodeListEntry[] = [
  {code: 'EA', label: 'Each'},
  {code: 'PC', label: 'Piece'},
  {code: 'CA', label: 'Case'},
  {code: 'BX', label: 'Box'},
  {code: 'CT', label: 'Carton'},
  {code: 'PK', label: 'Package'},
  {code: 'PL', label: 'Pallet/Unit Load'},
  {code: 'BG', label: 'Bag'},
  {code: 'BD', label: 'Bundle'},
  {code: 'KT', label: 'Kit'},
  {code: 'ST', label: 'Set'},
  {code: 'PR', label: 'Pair'},
  {code: 'DZ', label: 'Dozen'},
  {code: 'HU', label: 'Hundred'},
  {code: 'TH', label: 'Thousand'},
  {code: 'FT', label: 'Foot'},
  {code: 'LF', label: 'Linear Foot'},
  {code: 'IN', label: 'Inch'},
  {code: 'YD', label: 'Yard'},
  {code: 'MR', label: 'Meter'},
  {code: 'SF', label: 'Square Foot'},
  {code: 'RL', label: 'Roll'},
  {code: 'RE', label: 'Reel'},
  {code: 'DR', label: 'Drum'},
  {code: 'LB', label: 'Pound'},
  {code: 'KG', label: 'Kilogram'},
  {code: 'GA', label: 'Gallon'},
  {code: 'LO', label: 'Lot'},
  {code: 'UN', label: 'Unit'},
  {code: 'ZZ', label: 'Mutually Defined'},
];
